// Google Ads dashboard chart catalogue — PURE constants, a LEAF module.
//
// Extracted from GoogleAdsCharts.tsx to break a CIRCULAR IMPORT: the chart
// component (GoogleAdsCharts.tsx) imports `tileStyleFor` from googleAdsViewPrefs,
// and googleAdsViewPrefs imports these chart constants. When the production bundle
// happened to initialise the component first, `DEFAULT_GOOGLE_CHARTS` was still
// `undefined` at the point googleAdsViewPrefs's module-level default state spread
// it (`[...DEFAULT_GOOGLE_CHARTS]`) — a "not iterable" throw that failed the whole
// module import and white-screened the app. A green `npm run build` did not catch
// it because vitest/Node init order differs from the Vite bundle's.
//
// This module imports NOTHING from the module graph, so it is always fully
// initialised before either googleAdsViewPrefs or the chart component reads it —
// no cycle possible. Both import their chart constants from here.

export type GoogleChartKey = 'trend' | 'multiTrend' | 'competitiveness';

export const GOOGLE_CHARTS: Array<{ key: GoogleChartKey; label: string; hint: string }> = [
  { key: 'trend', label: 'Selected metric', hint: 'The KPI tile you clicked, over the period' },
  {
    key: 'multiTrend',
    label: 'Trend (multi-metric)',
    // The capability the single-metric chart deliberately does not give: several
    // metrics on ONE chart, for comparing their shapes over the same period.
    hint: 'Tick several metrics onto one chart — cost, conversions and CTR together',
  },
  {
    key: 'competitiveness',
    label: 'Auction competitiveness',
    hint: 'Impression share won vs lost to budget and to rank — Google-specific',
  },
];

export const DEFAULT_GOOGLE_CHARTS: GoogleChartKey[] = ['trend', 'multiTrend', 'competitiveness'];

const CHART_KEYS = new Set<GoogleChartKey>(GOOGLE_CHARTS.map((c) => c.key));

/** Drop unknowns, keep catalogue order. Empty is ALLOWED — hiding every chart is
 *  a legitimate choice here (unlike an empty metric list, which would leave the
 *  page with nothing at all). */
export function sanitizeCharts(stored: readonly string[]): GoogleChartKey[] {
  const wanted = new Set(
    stored.filter((k): k is GoogleChartKey => CHART_KEYS.has(k as GoogleChartKey)),
  );
  return GOOGLE_CHARTS.filter((c) => wanted.has(c.key)).map((c) => c.key);
}
